/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GenerateSettingsServiceDescriptionApiArg, SettingsGenerateServiceDescriptionResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    generateSettingsServiceDescription: build.mutation<
      SettingsGenerateServiceDescriptionResponse,
      GenerateSettingsServiceDescriptionApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/settings/services/generate-description`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as generateSettingsServiceDescriptionApi };
export const { useGenerateSettingsServiceDescriptionMutation } = injectedRtkApi;
